import { styled, Typography, Stack } from "@mui/material";

export const SearchTypography = styled(Typography)({
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--community-color-primary-text)",
});

export const SearchSectionStack = styled(Stack)({
    alignItems: "center",
    gap: "8px",
    flexDirection: "row",
});
